import {useMutation, useQuery, gql} from 'admin/lib/apollo'
import clearCache from './clearCache'

export const QUERY = gql`
  query GetAlerts($types: [String!], $ownerType: String, $ownerId: ID) {
    alerts(types: $types, ownerType: $ownerType, ownerId: $ownerId) {
      id
      payload
      type
      createdAt
      activateAt
      ... on AccountAlert {
        account {
          id
          name
          displayName @client
          contactFirstName
          contactLastName
        }
      }
    }
  }
`

export const MUTATION = gql`
  mutation UpdateAlert($id: ID!, $state: String) {
    alert(id: $id, state: $state) {
      id
      payload
      state
    }
  }
`

export default (organisationId, ownerType, ownerId, types) => {
  const {data} = useQuery(QUERY, {
    variables: {organisationId, ownerType, ownerId, types: Array.isArray(types) ? types : [types]}
  })

  const [update, {error: updateError}] = useMutation(MUTATION, {
    variables: {organisationId},
    update: (cache, {data: {alert}, errors}) => {
      // remove from cache when cleared
      if (errors || !alert) return
      if (alert.state === 'cleared') {
        cache.evict({id: cache.identify(alert)})
        cache.gc()
      }
      clearCache({organisation: null, accounts: null})(cache)
    }
  })

  return {
    alerts: data ? data.alerts : [],
    errors: updateError || {},
    update
  }
}
